import { Theme } from '@mui/material/styles';

export default function Chip(_theme: Theme) {
  return {
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          '&:active': {
            boxShadow: 'none',
          },
        },
      },
    },
  };
}
